import Component from "@ember/component"
import { inject as service } from "@ember/service"
import type { Planbook } from "@shared/models/planbook"
import type Dialog from "cc-frontend/services/dialog"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"
import type Session from "cc-frontend/services/session"
import { handleError } from "cc-frontend/error-handling"

export default class ShareLinkComponent extends Component {
  // args
  closeMenu!: Function
  planbook!: Planbook
  overridePath?: string
  overrideDateString?: string

  // state
  // services
  @service declare dialog: Dialog
  @service declare rpc: Rpc
  @service("ember-store") declare store: EmberStore
  @service declare session: Session
  // init
  // actions

  async click() {
    this.closeMenu()

    if (this.planbook.attributes.publicAccess.roles.length === 0) {
      if (this.planbook.meta.permissions.includes("can-change-collaborators")) {
        try {
          await this.dialog.blank("dialogs/ask-to-share-planbook-publicly", {
            className: "dialog--create-annotation",
          })
        } catch (error) {
          if (error instanceof Error) handleError(error)
          return
        }
      } else {
        try {
          await this.dialog.blank("dialogs/share-planbook-publicly-not-allowed", {
            className: "dialog--create-annotation",
          })
        } catch (error) {
          if (error instanceof Error) handleError(error)
        }
        return
      }
    }

    this.rpc.planbook_collaboration_change_public_permission({
      planbookId: this.planbook.id,
      role: "VIEWER",
    })

    this.dialog
      .blank("dialogs/public-link", {
        planbook: this.planbook,
        overridePath: this.overridePath,
        overrideDateString: this.overrideDateString,
        className: "dialog--public-link",
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }
}
